import { render, staticRenderFns } from "./error-screen.vue?vue&type=template&id=13cc7c92&"
import script from "./error-screen.vue?vue&type=script&lang=ts&"
export * from "./error-screen.vue?vue&type=script&lang=ts&"
import style0 from "./error-screen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports